import script from "./ReportTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportTable.vue?vue&type=script&lang=ts&setup=true"

import "./ReportTable.vue?vue&type=style&index=0&id=07b1ebf2&lang=scss"

const __exports__ = script;

export default __exports__